import styles from "./products.module.css";
import Product from "./Product/Product";
import { HeadingTitle, SwiperSlider } from "../../shared/index";
import { SwiperSlide } from "swiper/react";
const Products = ({
  title,
  products,
  variant = "slider",
  wishItems = [],
  isWishListPending,
  lastItemRef
}) => {
  const safeId = title?.replace(/\s+/g, "-").toLowerCase();
  return (
    <section className={styles.products__wrapper}> 
   
      {title && <HeadingTitle text={title} style={styles.heading} />}
      {variant === "slider" ? (
  <SwiperSlider
  prevId={`${safeId}-prev`}
  nextId={`${safeId}-next`}
  wrapperClass={styles.productsSlider}
  prevBtnClass={`${styles.navButton} ${styles.prevButton}`}
  nextBtnClass={`${styles.navButton} ${styles.nextButton}`}
  centeredSlides={false}
  slidesPerView={1}
  spaceBetween={16}
  breakpoints={{
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 22,
    },
    1280: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  }}
>
  {products?.map((product) => (
    <SwiperSlide key={product.id}>
      <Product
        product={product}
        wishItems={wishItems}
      />
    </SwiperSlide>
  ))}
</SwiperSlider>
      ) : ( 
        
        <div className={styles.productsGrid}>
          {products?.map((p,index) => (
            <Product
              product={p}
              key={p.id}
              wishItems={wishItems}
              isWishListPending={isWishListPending}
              ref={index === products.length - 1 ? lastItemRef : null}
            />
          ))}
        </div>
      )}
    </section>
  );
};
export default Products;